import '../assets/Paging.css';const r = "op_paginationHolder_6vNlM", p = "op_paginationNav_mw-Mk", u = "op_paginationLocation_KvxDn", n = {
  paginationHolder: r,
  paginationNav: p,
  paginationLocation: u
};
function m(i) {
  let e = parseInt(i.resultCount), a = parseInt(i.page), t = parseInt(i.limit), o = i.onClick, l = "", g = {}, s = {}, c = {};
  return e !== void 0 && e <= t ? /* @__PURE__ */ React.createElement("span", { className: n.paginationLocation, ...g }, "All results: ", e) : (a * t < e ? l = a * t : l = e, /* @__PURE__ */ React.createElement("div", { className: n.paginationHolder }, /* @__PURE__ */ React.createElement(
    "button",
    {
      value: a - 1,
      name: "page",
      className: n.paginationNav,
      onClick: o,
      disabled: a == 1,
      ...c
    },
    a == 1 ? /* @__PURE__ */ React.createElement(React.Fragment, null, "⤫") : /* @__PURE__ */ React.createElement(React.Fragment, null, "◄"),
    " Back"
  ), /* @__PURE__ */ React.createElement("span", { className: n.paginationLocation, ...s }, " ", a * t - t + 1 + "-" + l + " of " + e, " "), /* @__PURE__ */ React.createElement(
    "button",
    {
      value: a + 1,
      name: "page",
      className: n.paginationNav,
      onClick: o,
      disabled: a > 2 && a * t > e - t,
      ...c
    },
    "Next ",
    a > 2 && a * t > e - t ? /* @__PURE__ */ React.createElement(React.Fragment, null, "⤫") : /* @__PURE__ */ React.createElement(React.Fragment, null, "►")
  )));
}
export {
  m as Paging
};
